// Phase 85.A.150 — Global "upload in progress" flag để các gate khác (avatar
// proposal, pending rating proposal, …) KHÔNG re-fetch / re-render gây
// unmount modal upload trên iOS Safari sau khi user chọn file từ native
// picker.
//
// Cơ chế:
//   - markUploadActive(true)   khi modal upload mount với open=true.
//   - markUploadActive(false)  khi modal close.
//   - isUploadActive()         để các gate kiểm tra.
//   - subscribe(cb)            (optional) lắng nghe đổi trạng thái.
//
// Tại sao không dùng React Context? Context đòi hỏi tất cả gate providers
// phải nest đúng thứ tự + import context. Global window flag đơn giản hơn,
// chạy ngoài React render cycle, không gây re-render parent khi đổi.

const WIN_KEY = "__pickleagueUploadInProgress";
const EVT = "pickleague-upload-active-changed";

export function markUploadActive(active) {
  if (typeof window === "undefined") return;
  const prev = !!window[WIN_KEY];
  const next = !!active;
  if (prev === next) return;
  window[WIN_KEY] = next;
  try {
    window.dispatchEvent(new CustomEvent(EVT, { detail: { active: next } }));
  } catch {
    /* noop */
  }
}

export function isUploadActive() {
  if (typeof window === "undefined") return false;
  return !!window[WIN_KEY];
}

export function subscribeUploadActive(cb) {
  if (typeof window === "undefined" || typeof cb !== "function") return () => {};
  const handler = (e) => cb(!!e?.detail?.active);
  window.addEventListener(EVT, handler);
  return () => window.removeEventListener(EVT, handler);
}
